module.exports = __webpack_public_path__ + "img/icon_promo.8b219ac.webp";